var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M-686,252a10.011,10.011,0,0,1-10-10,10.011,10.011,0,0,1,10-10,10.011,10.011,0,0,1,10,10A10.011,10.011,0,0,1-686,252Zm0-18.448A8.457,8.457,0,0,0-694.447,242,8.457,8.457,0,0,0-686,250.448,8.457,8.457,0,0,0-677.553,242,8.457,8.457,0,0,0-686,233.552Zm4.4,12.128-2.542-3.877,2.4-3.484h-2.64L-686,240.84l-1.624-2.521h-2.641l2.4,3.484-2.542,3.877h2.8l1.6-2.582,1.6,2.582Z",
    transform: "translate(696 -232)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorType);
export default __webpack_public_path__ + "static/media/errorType.5f4b272f.svg";
export { ForwardRef as ReactComponent };